import React from 'react';
import {
  Box, Button, TextField, MenuItem, IconButton, Tooltip,
  CircularProgress,
} from '@mui/material';
import {
  Save as SaveIcon,
  PlayArrow as RunIcon,
  Download as DownloadIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

export default function ReportBuilderToolbar({
  reports,
  selectedReportId,
  onSelectReport,
  reportName,
  onReportNameChange,
  dataSource,
  onDataSourceChange,
  onSave,
  onRunPreview,
  onExport,
  onNewReport,
  onTogglePanel,
  isPanelOpen,
  isLoading,
  isSaving,
  hasChanges,
}) {
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5,
      borderBottom: '1px solid #e0e0e0', flexWrap: 'wrap',
    }}>
      {/* Report selector */}
      <TextField
        select size="small" label="Report"
        value={selectedReportId || ''}
        onChange={(e) => onSelectReport(e.target.value)}
        sx={{ minWidth: 180 }}
        SelectProps={{ displayEmpty: true }}
        InputLabelProps={{ shrink: true }}
      >
        <MenuItem value="">
          <em>New Report</em>
        </MenuItem>
        {(reports || []).map(r => (
          <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
        ))}
      </TextField>

      {/* Report name */}
      <TextField
        size="small" label="Report Name"
        value={reportName}
        onChange={(e) => onReportNameChange(e.target.value)}
        sx={{ minWidth: 200 }}
      />

      {/* Data source */}
      <TextField
        select size="small" label="Data Source"
        value={dataSource}
        onChange={(e) => onDataSourceChange(e.target.value)}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="time_entries">Time Entries</MenuItem>
        <MenuItem value="expenses">Expenses</MenuItem>
        <MenuItem value="invoices">Invoices</MenuItem>
      </TextField>

      <Box sx={{ flex: 1 }} />

      {/* Actions */}
      <Button
        size="small" variant="outlined"
        startIcon={isLoading ? <CircularProgress size={16} /> : <RunIcon />}
        onClick={onRunPreview}
        disabled={isLoading}
      >
        Preview
      </Button>

      <Button
        size="small" variant="contained"
        startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
        onClick={onSave}
        disabled={isSaving}
        color={hasChanges ? 'warning' : 'primary'}
      >
        Save
      </Button>

      <Button
        size="small" variant="outlined"
        startIcon={<DownloadIcon />}
        onClick={onExport}
      >
        Excel
      </Button>

      <Tooltip title={isPanelOpen ? 'Hide Config Panel' : 'Show Config Panel'}>
        <IconButton size="small" onClick={onTogglePanel} color={isPanelOpen ? 'primary' : 'default'}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
